/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Import_Downloadsample1Inputs */



/**
* | output |
* | --- |
* | "Download sample CSV" |
*
* @param {Alarms_Import_Downloadsample1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_import_downloadsample1 = /** @type {((inputs?: Alarms_Import_Downloadsample1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Import_Downloadsample1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Download sample CSV")
	return /** @type {LocalizedString} */ ("Télécharger un CSV exemple")
});
export { alarms_import_downloadsample1 as "alarms_import_downloadSample" }